import React, { useEffect, useState } from "react";
import CreateInvoiceQpay from "../../functions/invoice/createInvoiceQpay";
import { useUser } from "../../screens/user/context.js/userContext";

const QpayBankList = ({ invoiceId }) => {
  const [data, setData] = useState(null);
  const { setPaying } = useUser();
  useEffect(() => {
    if (invoiceId && !data) fetchQpayData();
  }, [invoiceId]);

  const fetchQpayData = async () => {
    setPaying("Төлбөрийн мэдээлэл татаж байна...");
    const response = await CreateInvoiceQpay(invoiceId);
    setPaying(null);
    if (!response || !response.data) return;
    setData(response.data.data.urls);
  };
  const allowedBanks = [
    "Khan bank",
    "State bank 3.0",
    "Xac bank",
    "Trade and Development bank",
    "Capitron bank",
    "Social Pay",
    "Bogd bank",
    "M bank",
    "Monpay",
  ];
  const navigate = (link) => {
    try {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: "link",
          url: link,
        }),
      );
    } catch (e) {
      window.location.href = link;
    }
  };
  //.filter((e) => allowedBanks.includes(e.name))

  return (
    <div className="p-1 ">
      <span className="text-gray-200 ml-2">Банкны аппликейшнээр</span>
      <div className="flex flex-row gap-2 pb-3 overflow-x-auto justify-between mt-2">
        <div className="flex flex-row gap-3">
          {data &&
            data.map((bank, index) => (
              <div
                key={index}
                onClick={() => navigate(bank.link)}
                className="rounded-lg w-[90px] flex items-center justify-center flex-col p-2 bg-gray-600"
              >
                <img
                  src={bank.logo}
                  alt={bank.name}
                  className="bankIcon"
                  width="50"
                  height="50"
                />
                <span className="text-xs mt-2 text-center text-gray-200">
                  {bank.description}
                </span>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default QpayBankList;
